<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="托盘商编码">
                                <el-input clearable v-model.trim="q.companyCode"></el-input>
                            </el-form-item>
                            <el-form-item label="托盘商名称">
                                <el-input clearable v-model.trim="q.companyName"></el-input>
                            </el-form-item>
                            <el-form-item label="电商平台" prop="platformName" class="h-elformWrap-2">
                                <brselect clearable :dictNameAsValues=true category="platform_name" :v="q.platformName" v-model="q.platformName"></brselect>
                            </el-form-item>
                        </div>
                        <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                       @click="createdict">新建</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="h-table h-mrt30">
                <el-table
                    @selection-change="handleSelectionChange"
                    ref="ddtable"
                    :data="tableData"
                    stripe
                    border
                    style="width: 100%"
                >
                    <el-table-column
                        type="selection"
                        width="40"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="companyCode"
                        label="托盘商编码"
                        width="120"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="companyName"
                        label="托盘商名称"
                        width="160"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="ownerName"
                        label="负责人"
                        width="120"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="phone"
                        label="联系电话"
                        width="140"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="platformName"
                        label="电商平台"
                        width="160"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="cuname"
                        label="创建人"
                        width="120"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="cdate"
                        label="创建时间"
                        width="140"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="lucode"
                        label="修改人"
                        width="120"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="ldate"
                        label="修改时间"
                        width="140"
                    >
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="160"
                    >
                        <template slot-scope="scope">
                            <el-button
                                class="h-tableLink h-btn"
                                @click="handleEdit(scope.row)">修改</el-button>
                            <el-button
                                class="h-tableLink h-btn"
                                @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableBL" style="margin:20px 0 0 20px;display:flex;justify-content:space-between">
                    <div>
                        <el-button
                            class="h-btn h-formBtn h-bgblueQ"
                            icon="h-el-icon h-el-icon-import"
                            style="margin-left:-20px;"
                            @click="exportExcel" >
                            批量导出
                        </el-button>
                    </div>
                    <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>

            <div>
                <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2">
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>修改（新建）托盘商电商平台负责人</h1>
                            </div>
                        </div>
                    </div>
                    <div class="h-formLine">
                        <el-form ref="form" :model="f" :rules="rules"
                                 :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">

                            <el-form-item label="托盘商编码" prop="companyCode" class="h-elformWrap-2">
                                <el-input v-model.trim="f.companyCode"  @change="checkUser"></el-input>
                            </el-form-item>


                            <el-form-item label="托盘商名称" prop="companyName" class="h-elformWrap-2">
                                <el-input v-model.trim="f.companyName"></el-input>
                            </el-form-item>

                            <el-form-item label="负责人" prop="ownerName" class="h-elformWrap-2">
                                <el-input v-model.trim="f.ownerName"></el-input>
                            </el-form-item>

                            <el-form-item label="联系电话" prop="phone" class="h-elformWrap-2">
                                <el-input v-model.trim="f.phone"></el-input>
                            </el-form-item>

                            <el-form-item label="电商平台" prop="platformName" class="h-elformWrap-2">
                                <brselect clearable :dictNameAsValues=true category="platform_name" :v="f.platformName" v-model="f.platformName"  :multiple="true" ></brselect>
                            </el-form-item>

                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="closeM">取 消</el-button>
                        <el-button class="h-btn h-formBtn h-bgblue2" @click="saveOrUpdate">提交保存</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>

import ss from "@/api/SystemService";
import updownfile from '../../../utils/updownfile'
export default {
    components: {

    },
    data() {

        return {
            uploaddownexcelflag: false,
            //table列表
            tableData: [],
            //查询属性
            q: {
                companyCode: null,
                companyName: null,
                ownerName: null,
                platformName: null,
                pageSize: 10,
                pageNo: 1,
                total: 0,
            },
            //表单
            f:{
                id:null,
                companyCode:null,
                companyName:null,
                ownerName:null,
                phone:null,
                platformName:null,
            },
            //校验规则（统一配置，保证提交时全部触发校验）
            rules: {
                companyCode: [
                    { required: true, message: '请输入托盘商编码', trigger: 'blur' },
                ],
                companyName: [
                    { required: true, message: '请输入托盘商名称', trigger: 'blur' },
                ],
                ownerName: [
                    { required: true, message: '请输入负责人', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                ],
                platformName: [
                    { required: true, message: '请选择电商平台', trigger: 'blur' },
                ],
            },
            optflag:'save',
            //弹出框
            dialogFormVisible: false,
            //表格
            multipleSelection: [],
        }
    },
    created() {
        this.query();
    },
    methods: {

        //检查用户是否存在
        checkUser(code){
            ss.UserService.selectById(code).then(rd => {
                if(rd.obj==null){
                    this.$msg.msge("该经销商在系统中不存在！");
                    this.f.companyCode ='';
                    this.f.companyName ='';
                }else{
                    this.f.companyName = rd.obj.username;
                }
            })
        },
        query() {
            ss.BscPalletDealer.selectPage(this.q).then(rd => {
                this.q.total = rd.total;
                this.tableData = rd.records;
            })
        },

        handleFilter() {
            this.query();
        },

        createdict(){
            this.f = {
                id: null,
                companyCode: null,
                companyName: null,
                ownerName: null,
                phone: null,
                platformName: null,
            };
            this.dialogFormVisible = true;
            this.optflag = 'save'
        },

        handleEdit(obj){
            this.f = {
                ...obj
            };
            this.dialogFormVisible = true;
            this.optflag = 'update'
        },

        handleDelete(obj){
            this.$msg.confirm("确认删除?",()=>{
                ss.BscPalletDealer.deleteById({id:obj.id}).then(rd=>{
                    this.$msg.msgs("删除成功！");
                    this.query();
                });
            })
        },

        //保存
        saveOrUpdate(){
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    var retobj = null;
                    if(this.optflag == 'save'){
                        retobj = ss.BscPalletDealer.insert(this.f);
                    }else if(this.optflag =="update"){
                        retobj = ss.BscPalletDealer.updateById(this.f);
                    }
                    retobj.then(rd=>{
                        this.dialogFormVisible = false;
                        this.$msg.msgs("操作成功！");
                        this.query();
                    });
                } else {
                    return false;
                }
            });
        },

        //关闭
        closeM(){
            this.dialogFormVisible = false;
        },

        //选中
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //明细导出
        exportExcel() {
            var idlist = [];
            this.multipleSelection.forEach(element => {
                idlist.push(element.id);
            });
            updownfile.down("/api/swyl/v1/demo/bscPalletDealer/downloadExcel", idlist, "get", 'data');
        },
    }
}
</script>
